import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { messages } from 'src/app/popUpMessages/messages';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ScenarioComponent } from '../../eq-tagercosting/scenario/scenario.component';

let countryCode;

@Component({
  selector: 'app-cs-calc-popup',
  templateUrl: './cs-calc-popup.component.html',
  styleUrls: ['./cs-calc-popup.component.css']
})
export class CsCalcPopupComponent implements OnInit {
  selectedData: any;

  constructor(
    public dialogRef: MatDialogRef<CsCalcPopupComponent>,
    public dialog: MatDialog,
    private router: Router,
    private localStorageService: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public totalBkS3 = this.data.totalBK;
  public crp = this.data.crp;
  public margin = this.data.margin;
  public bk = this.data.bk;
  public scenario = this.data.scenario;
  public columnDefs: any;
  public rowData: any;
  public defaultColDef: any;
  public showGrid = false;
  public gridApi: any;
  public gridColumnApi: any;
  public selectedScenario: any;
  gridRowData: any[];
  public totalBK = 0;
  public totalCrpData = 0;
  public modifiedRowsData = [];
  domLayout: any;

  ngOnInit(): void {
    countryCode = this.localStorageService.get('countryCode');
    this.loadGrid();
  }

  loadGrid() {
    let regex = new RegExp(/^\\s*$/);
    this.columnDefs = [
      {
        headerName: "",
        field: "Name",
        tooltipField: "Name",
        headerTooltip: "Name",
        editable: false,
        cellStyle: { fontWeight: 'bold' }
      },

      {
        headerName: "Price & Margin in %",
        field: "Scenario1",
        tooltipField: "Scenario1",
        headerTooltip: "Scenario1",
        cellClass: params => (params.data.Name === "CS Costs Target, abs") ? 'colorTotal' : '',
        cellRendererFramework: ScenarioComponent,
        tooltipValueGetter: CurrencyCellRenderer,
        editable: (params: any) => {
          if (params.data.Name == null || params.data.Name == 'CS Costs Target, abs') {
            return false
          }
          else {
            return true
          }
        },
        singleClickEdit: true,
        valueGetter: (params) => {
          if (params.node.data.Name == "CS Costs Target, abs") {
            let marginData;
            let crpData;
            crpData = Number(params.api.getDisplayedRowAtIndex(1).data.Scenario1)
            marginData = Number(params.api.getDisplayedRowAtIndex(2).data.Scenario1) / 100;
            let calculation = crpData * (1 - marginData);
            if (isNaN(calculation)) {
              calculation = 0;
            }
            params.api.getDisplayedRowAtIndex(3).data.Scenario1 = calculation;
            return calculation;
          }
          return (params.data.Scenario1);
        }
      },
      {
        headerName: "Price & CS Costs",
        field: "Scenario4",
        tooltipField: "Scenario4",
        headerTooltip: "Scenario4",
        cellRendererFramework: ScenarioComponent,
        tooltipValueGetter: CurrencyCellRenderer,
        cellClass: params => (params.data.Name === "Margin in % of Price") ? 'colorTotal' : '',
        editable: (params: any) => {
          if (params.data.Name == null || params.data.Name == 'Margin in % of Price') {
            return false
          }
          else {
            return true
          }
        },
        singleClickEdit: true,
        valueGetter: (params) => {
          if (params.node.data.Name == "Margin in % of Price") {
            let BKData;
            let crpData;
            crpData = Number(params.api.getDisplayedRowAtIndex(1).data.Scenario4)
            BKData = Number(params.api.getDisplayedRowAtIndex(3).data.Scenario4);
            let calculation = ((crpData - BKData) / crpData) * 100;
            params.api.getDisplayedRowAtIndex(2).data.Scenario4 = calculation;

            if (isNaN(calculation)) {
              calculation = 0;
            }

            return calculation;
          }
          return (params.data.Scenario4);
        }
      },
      {
        headerName: "Margin in % & CS Costs",
        field: "Scenario2",
        tooltipField: "Scenario2",
        headerTooltip: "Scenario2",
        tooltipValueGetter: CurrencyCellRenderer,
        cellClass: params => (params.data.Name === "Price, abs") ? 'colorTotal' : '',
        editable: (params: any) => {
          if (params.data.Name == null || params.data.Name == 'Price, abs') {
            return false
          }
          else {
            return true
          }
        },
        singleClickEdit: true,
        cellRendererFramework: ScenarioComponent,
        valueGetter: (params) => {
          if ((params.data.Name == 'Price, abs')) {
            let marginData;
            let bkData;
            bkData = params.column.colId === 'Price, abs';
            bkData = Number(params.api.getDisplayedRowAtIndex(3).data.Scenario2)
            marginData = Number(params.api.getDisplayedRowAtIndex(2).data.Scenario2) / 100;
            let calculation = bkData / (1 - marginData);
            params.api.getDisplayedRowAtIndex(1).data.Scenario2 = calculation;
            if (isNaN(calculation)) {
              calculation = 0;
            }
            return calculation;
          }
          return (params.data.Scenario2);
        }
      },
      {
        headerName: "Margin in %",
        field: "Scenario3",
        tooltipField: "Scenario3",
        headerTooltip: "Scenario3",
        tooltipValueGetter: CurrencyCellRenderer,
        cellRendererFramework: ScenarioComponent,
        cellClass: params => (params.data.Name === "Price, abs" || params.data.Name === "CS Costs Target, abs") ? 'colorTotal' : '',
        editable: (params: any) => {
          if (params.data.Name == null || params.data.Name == 'Price, abs' || params.data.Name == 'CS Costs Target, abs') {
            return false
          }
          else {
            return true
          }
        },
        singleClickEdit: true,
        valueGetter: (params) => {
          //   debugger;
          if ((params.data.Name == 'Price, abs')) {
            let marginData;
            let bkData;
            bkData = Number(params.api.getDisplayedRowAtIndex(3).data.Scenario3)
            marginData = Number(params.api.getDisplayedRowAtIndex(2).data.Scenario3) / 100;
            let calculation = bkData / (1 - marginData);
            params.api.getDisplayedRowAtIndex(1).data.Scenario3 = calculation;
            if (isNaN(calculation)) {
              calculation = 0;
            }
            return calculation;
          }
          return (params.data.Scenario3);

        }
      },


    ];

    this.domLayout = 'autoHeight';
    this.showGrid = true;
    this.rowData = [
      { Scenario1: false, Scenario2: false, Scenario3: false, Scenario4: false, Name: null },
      { Scenario1: null, Scenario2: null, Scenario3: null, Scenario4: null, Name: 'Price, abs' },
      { Scenario1: null, Scenario2: null, Scenario3: null, Scenario4: null, Name: 'Margin in % of Price' },
      { Scenario1: null, Scenario2: null, Scenario3: this.totalBkS3, Scenario4: null, Name: 'CS Costs Target, abs' },
    ];

    switch (this.scenario) {

      case 1: {
        // debugger;
        this.rowData.find(x => x.Name == null).Scenario1 = true;
        this.rowData.find(x => x.Name == "Price, abs").Scenario1 = this.crp;
        this.rowData.find(x => x.Name == "Margin in % of Price").Scenario1 = this.margin;
        this.rowData.find(x => x.Name == "CS Costs Target, abs").Scenario1 = this.bk;
        break;
      };
      case 2: {
        this.rowData.find(x => x.Name == null).Scenario2 = true;
        this.rowData.find(x => x.Name == "Price, abs").Scenario2 = this.crp;
        this.rowData.find(x => x.Name == "Margin in % of Price").Scenario2 = this.margin;
        this.rowData.find(x => x.Name == "CS Costs Target, abs").Scenario2 = this.bk;
        break;
      };
      case 3: {
        // debugger;
        this.rowData.find(x => x.Name == null).Scenario3 = true;
        this.rowData.find(x => x.Name == "Price, abs").Scenario3 = this.crp;
        this.rowData.find(x => x.Name == "Margin in % of Price").Scenario3 = this.margin;
        this.rowData.find(x => x.Name == "CS Costs Target, abs").Scenario3 = this.totalBkS3;
        break;
      };
      case 4: {
        // debugger;
        this.rowData.find(x => x.Name == null).Scenario4 = true;
        this.rowData.find(x => x.Name == "Price, abs").Scenario4 = this.crp;
        this.rowData.find(x => x.Name == "Margin in % of Price").Scenario4 = this.margin;
        this.rowData.find(x => x.Name == "CS Costs Target, abs").Scenario4 = this.bk;
        break;
      }
    }
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGridSizeChanged(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }
  onCellValueChanged(params) {
  }
  checkboxchecked(event) {
  }
  onSubmit(event?: any) {
    let flagresponse = 0, scenario, crp, margin, bk;

    if (this.gridApi.getDisplayedRowAtIndex(0).data.Scenario1 == false && this.gridApi.getDisplayedRowAtIndex(0).data.Scenario2 == false && this.gridApi.getDisplayedRowAtIndex(0).data.Scenario3 == false && this.gridApi.getDisplayedRowAtIndex(0).data.Scenario4 == false) {
      this.openAlertDialog([{ [messages.csScenario]: serverMessage.warning }]);
      flagresponse = 1;
    }
    else if (this.gridApi.getDisplayedRowAtIndex(0).data.Scenario1 == true) {
      if (this.gridApi.getDisplayedRowAtIndex(1).data.Scenario1 == null || this.gridApi.getDisplayedRowAtIndex(2).data.Scenario1 == null) {
        this.openAlertDialog([{ [messages.csMarginAndPriceData]: serverMessage.warning }]);
        flagresponse = 1;
      }
      else {
        scenario = 1;
        crp = this.gridApi.getDisplayedRowAtIndex(1).data.Scenario1;
        margin = this.gridApi.getDisplayedRowAtIndex(2).data.Scenario1;
        bk = this.gridApi.getDisplayedRowAtIndex(3).data.Scenario1;
      }
    }
    else if (this.gridApi.getDisplayedRowAtIndex(0).data.Scenario2 == true) {
      if (this.gridApi.getDisplayedRowAtIndex(2).data.Scenario2 == null || this.gridApi.getDisplayedRowAtIndex(3).data.Scenario2 == null) {
        this.openAlertDialog([{ [messages.csMarginAndBkData]: serverMessage.warning }]);
        flagresponse = 1;
      }
      else {
        scenario = 2;
        crp = this.gridApi.getDisplayedRowAtIndex(1).data.Scenario2;
        margin = this.gridApi.getDisplayedRowAtIndex(2).data.Scenario2;
        bk = this.gridApi.getDisplayedRowAtIndex(3).data.Scenario2;
      }
    }
    else if (this.gridApi.getDisplayedRowAtIndex(0).data.Scenario3 == true) {
      if (this.gridApi.getDisplayedRowAtIndex(2).data.Scenario3 == null) {
        this.openAlertDialog([{ [messages.csMarginData]: serverMessage.warning }]);
        flagresponse = 1;
      }
      else {
        scenario = 3;
        crp = this.gridApi.getDisplayedRowAtIndex(1).data.Scenario3;
        margin = this.gridApi.getDisplayedRowAtIndex(2).data.Scenario3;
        bk = this.gridApi.getDisplayedRowAtIndex(3).data.Scenario3;
      }
    }
    else if (this.gridApi.getDisplayedRowAtIndex(0).data.Scenario4 == true) {
      if (this.gridApi.getDisplayedRowAtIndex(1).data.Scenario4 == null || this.gridApi.getDisplayedRowAtIndex(3).data.Scenario4 == null) {
        this.openAlertDialog([{ [messages.csBkAndCrpData]: serverMessage.warning }]);
        flagresponse = 1;
      }
      else {
        scenario = 4;
        crp = this.gridApi.getDisplayedRowAtIndex(1).data.Scenario4;
        margin = this.gridApi.getDisplayedRowAtIndex(2).data.Scenario4;
        bk = this.gridApi.getDisplayedRowAtIndex(3).data.Scenario4;
      }
    }
    if (flagresponse == 0) {
      this.selectedData = {
        Scenario: scenario,
        CRP: crp,
        Margin: margin,
        BK: bk
      }
      this.dialogRef.close(this.selectedData);
    }
  }

}
function CurrencyCellRenderer(params: any) {
  return params.value == undefined ? null : new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)));
}
